//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AngTol",1,0],[0,"AngularThreshold",1,0],[0,"ContinuityType",1,0],[0,"DisTol",1,0],[1,"DistanceThreshold",0,"Expression",0],[1,"Edges",0,"ScCollector",0],[1,"FixedFaces",0,"ScCollector",0],[0,"MaintainG1Edges",1,0],[0,"MaxDiscontinuityLabelMethod",1,0],[1,"SharpEdges",0,"ScCollector",0],[1,"SheetBodies",0,"SelectDisplayableObjectList",0],[0,"ToleranceMarkup",1,0],[0,"Type",1,0]],[],[]];
SPLM.Features.HealSurfaceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.HealSurfaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.HealSurfaceBuilder.HealTypes = Object.freeze({
    "RemoveGashes" : "RemoveGashes", "HealInternalEdges" : "HealInternalEdges"});

SPLM.Features.HealSurfaceBuilder.ContinuityTypes = Object.freeze({
    "G0Position" : "G0Position", "G1Tangent" : "G1Tangent"});

SPLM.Features.HealSurfaceBuilder.MaxDiscontinuityLabelMethods = Object.freeze({
    "None" : "None", "PerEdge" : "PerEdge", "PerBody" : "PerBody"});

export default SPLM;